import { render, staticRenderFns } from "./ManufacturerHistory.vue?vue&type=template&id=34cf27bc"
import script from "./ManufacturerHistory.vue?vue&type=script&lang=js"
export * from "./ManufacturerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports